export default __webpack_public_path__ + "static/media/image4.d4fe2213.jpg";